// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__AU2d9"};